import route from 'ziggy-js';
import { createApp, h } from 'vue';
import Vue3Toasity, { toast } from 'vue3-toastify';
import { createInertiaApp, Link } from '@inertiajs/vue3';
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { resolvePageComponent } from 'laravel-vite-plugin/inertia-helpers';
import { faServer, faXmark, faList, faTableCellsLarge, faPlus, faArrowRight, faBars, faCode, faPenRuler, faBuildingColumns, faCheck, faExclamation, faCircleInfo, faCircleCheck, faTriangleExclamation, faCircleExclamation, faUpRightFromSquare, faPlay, faStop, faTrash, faMicrochip, faMemory, faHdd, faEthernet, faBuilding } from '@fortawesome/free-solid-svg-icons';
import { faUbuntu, faIdeal, faCentos, faSuse, faFedora, faLinux, faCcMastercard, faCcAmex, faCcDiscover, faCcDinersClub, faCcJcb, faCcVisa, faWindows } from '@fortawesome/free-brands-svg-icons';

import '../css/app.css';
import { dcaRoute } from './utils';
import 'vue3-toastify/dist/index.css';

library.add(faPenRuler, faList, faTableCellsLarge, faPlus, faXmark, faCentos, faSuse, faFedora, faArrowRight, faBars, faCode, faServer, faIdeal, faCcVisa, faCcMastercard, faCcAmex, faCcDiscover, faCcDinersClub, faCcJcb, faBuildingColumns, faCheck, faExclamation, faCircleInfo, faCircleCheck, faTriangleExclamation, faCircleExclamation, faUpRightFromSquare, faPlay, faStop, faTrash, faMicrochip, faMemory, faHdd, faEthernet, faBuilding, faUbuntu, faWindows, faLinux)

createInertiaApp({
    progress: {
        color: '#2580be',
    },
    title: (title) => title,
    // @ts-ignore
    resolve: (name) => resolvePageComponent(`./Pages/${name}.vue`, import.meta.glob('./Pages/**/*.vue')),
    // @ts-ignore
    setup({ el, App, props, plugin }) {
        const myApp = createApp({
            render: () => h(App, props),
        })
            .use(plugin)
            .use(Vue3Toasity, {
                theme: 'colored',
                autoClose: true,
                closeOnClick: true,
                position: toast.POSITION.BOTTOM_RIGHT
            })
            .component('fa', FontAwesomeIcon)
            .component('Link', Link)
            // @ts-ignore
            .mixin({
                methods: {
                    route: (name, params, absolute, config) => route(name, params, absolute, config),
                    dcaRoute: (name, params, absolute, config) => dcaRoute(name, params, absolute, config)
                }
            });

        myApp.mount(el);
        return myApp;
    },
});
